import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, Mail, Download, Infinity as InfinityIcon, Star } from 'lucide-react';
const steps = [{
  icon: CreditCard,
  title: 'Compras con pago seguro',
  description: 'Realiza tu pago de forma 100% segura y protegida.'
}, {
  icon: Mail,
  title: 'Recibes un email inmediato',
  description: 'Te llega la confirmación a tu correo al instante.'
}, {
  icon: Download,
  title: 'Descargas tu PDF al instante',
  description: 'Sin esperas ni envíos: acceso digital inmediato.'
}, {
  icon: InfinityIcon,
  title: 'Acceso de por vida',
  description: 'Disponible en cualquier dispositivo, cuando quieras.'
}];
export function HowItWorks() {
  return <section className="py-20 bg-white" data-id="element-96">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-98">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-99">
            📱 ¿Cómo lo recibes?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-100">
            Es 100% digital y súper sencillo. En cuestión de minutos tendrás
            todo en tus manos.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-101">
          {steps.map((step, index) => {
          const Icon = step.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="relative bg-brand-bg p-6 rounded-2xl text-center" data-id="element-102">
                <div className="w-12 h-12 bg-brand-accent text-white rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-103">
                  <Icon className="w-6 h-6" data-id="element-104" />
                </div>
                <span className="absolute top-4 right-4 text-xs font-bold text-brand-primary/40" data-id="element-105">
                  0{index + 1}
                </span>
                <h3 className="text-base font-bold text-gray-900 mb-2 leading-snug" data-id="element-106">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-107">
                  {step.description}
                </p>
              </motion.div>;
        })}
        </div>

        <div className="text-center" data-id="element-108">
          <a href="https://noveliahub.com/cart/50878318477348:1" className="inline-block w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white text-xl font-bold py-5 px-10 rounded-full shadow-[0_8px_30px_rgba(249,115,22,0.5)] transition-transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-orange-400/60 animate-pulse" data-id="element-109">
            Quiero mi acceso inmediato
          </a>

          <div className="mt-6 flex flex-col items-center gap-3" data-id="element-110">
            <div className="flex items-center gap-2" data-id="element-111">
              <div className="flex text-yellow-400" data-id="element-112">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-113" />)}
              </div>
              <span className="text-gray-700 font-medium" data-id="element-114">
                4.9/5 — opiniones verificadas
              </span>
            </div>
            <div className="flex items-center gap-2 text-gray-700 font-medium" data-id="element-115">
              <span aria-hidden="true" data-id="element-116">🛡️</span>
              <span data-id="element-117">Garantía de 60 Días — Riesgo cero</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}